export default __webpack_public_path__ + "static/media/message-blue-tick.8efd3973.svg";